import React from 'react';

import { TestID } from '../../testID';

export const EntityCopyConfigWarningMessage: React.FC = () => (
  <span className="copy-unsaved-message" data-testid={TestID.CopyUnsavedConfigMessage}>
    ⚠️ You have unsaved configuration changes and can copy them from the section below. This is the
    only option, and once you navigate away from this page, it will no longer be possible.
  </span>
);
